import React from "react";

const MAP = {
  approved: "bg-emerald-100 text-emerald-800 border-emerald-300",
  pending: "bg-amber-100 text-amber-800 border-amber-300",
  rejected: "bg-red-100 text-red-800 border-red-300",
  open: "bg-indigo-100 text-indigo-800 border-indigo-300",
  closed: "bg-slate-200 text-slate-700 border-slate-300",
  submitted: "bg-blue-100 text-blue-800 border-blue-300",
  shortlisted: "bg-violet-100 text-violet-800 border-violet-300",
  awarded: "bg-emerald-100 text-emerald-800 border-emerald-300",
};

export const StatusBadge = ({ status, className = "" }) => {
  const cls = MAP[status] || "bg-slate-100 text-slate-700 border-slate-300";
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold capitalize tracking-wide ${cls} ${className}`}
    >
      {status}
    </span>
  );
};

export const TypeBadge = ({ type }) => (
  <span className="inline-flex items-center rounded-md border border-slate-300 bg-slate-900 px-2 py-0.5 font-mono text-[11px] font-semibold uppercase tracking-wider text-white">
    {type}
  </span>
);
